import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Image inside a clipped frame with subtle vertical parallax on scroll.
const ParallaxImage = ({
  src,
  alt,
  className = "",
  overlay = "",
  loading = "lazy",
  decoding = "async",
  priority = false,
  sizes,
  srcSet,
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        loading={priority ? "eager" : loading}
        decoding={decoding}
        fetchPriority={priority ? "high" : undefined}
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover"
      />
      {overlay && <div className={`absolute inset-0 ${overlay}`} />}
    </div>
  );
};

export default ParallaxImage;
